import { useAuth } from 'react-oidc-context';

import { AppAuthConfig } from '~src/main/config';

export function useLogout() {
  const { signoutRedirect, removeUser } = useAuth();

  async function logout() {
    await removeUser();
    await signoutRedirect({
      extraQueryParams: {
        returnTo: `${window.location.protocol}//${window.location.host}/logged-out`,
        client_id: AppAuthConfig.client_id,
      },
    });
  }

  return {
    logout,
  };
}
